<div class="content__inner">
    <header class="content__title">
        <h1>{{ "simcards.list.title" | translate }}</h1>
        <small>{{ "simcards.list.subtitle" | translate }}</small>

        <div class="actions"></div>
    </header>

    <div class="card" *appHasPermission="'SIMCARDS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "simcards.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="iccid">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.iccid" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.iccid }}</td>
                    </ng-container>

                    <ng-container matColumnDef="imei">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.imei" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.imei }}</td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.state" | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            {{ row.state }}
                            <div *ngIf="row.deactivationReason">
                                <small>{{ "simcards.props.deactivationReason" | translate }}: {{ row.deactivationReason }}</small>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef>{{ "simcards.props.user" | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <ng-container *ngIf="row.user">
                                {{ row.user.email }}<span *ngIf="row.user.firstname || row.user.lastname"> ({{ row.user.firstname }} {{ row.user.lastname }})</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="firstActivation">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.firstActivation" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.firstActivation | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="pendingSince">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.pendingSince" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.pendingSince | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="scheduledSuspensionDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.scheduledSuspensionDate" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.scheduledSuspensionDate | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "simcards.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end align-items-center">
                                <ng-container *ngIf="row.state === 'deactivated'">
                                    <button (click)="activateSimCard(row._id)" class="btn btn-sm btn-success" *appHasPermission="'SIMCARDS.ACTIVATE'">{{ "simcards.list.activate.button" | translate }}</button>
                                </ng-container>
                                <ng-container *ngIf="row.state === 'activated'">
                                    <button (click)="deactivateSimCard(row._id)" class="btn btn-sm btn-danger" *appHasPermission="'SIMCARDS.DEACTIVATE'">{{ "simcards.list.deactivate.button" | translate }}</button>
                                </ng-container>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="viewSimCard(row._id)" class="zmdi zmdi-eye zmdi-hc-fw tableIcon" *appHasPermission="'SIMCARDS.VIEW'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
